module.exports = __webpack_public_path__ + "static/media/RareBERKgallery.8d3491bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/RareBERKgallery.png
// module id = 269
// module chunks = 0